import { render, staticRenderFns } from "./Navigation-main.vue?vue&type=template&id=38815a3b&scoped=true"
import script from "./Navigation-main.vue?vue&type=script&lang=js"
export * from "./Navigation-main.vue?vue&type=script&lang=js"
import style0 from "./Navigation-main.vue?vue&type=style&index=0&id=38815a3b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38815a3b",
  null
  
)

export default component.exports